export default {
  header: {
    home: 'Home',
    categories: 'Categories',
    about: 'About',
    searchPlaceholder: 'Search games...',
    toggleDarkMode: 'Toggle dark mode',
    toggleLightMode: 'Toggle light mode',
    changeLanguage: 'Change language'
  },
  nav: {
    home: 'Home',
    categories: 'Categories',
    popular: 'Popular',
    favorites: 'Favorites',
    search: 'Search...',
    login: 'Login',
    register: 'Register',
    myProfile: 'My Profile',
    settings: 'Settings',
    logout: 'Logout',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    language: 'Language',
    about: 'About'
  },
  footer: {
    about: 'About Us',
    contact: 'Contact',
    contactUs: 'Contact Us',
    policy: 'Privacy Policy',
    terms: 'Terms of Service',
    copyright: '© {year} GoGameVault. All rights reserved.',
    playOnline: 'Play Online',
    bestGames: 'Best Games',
    newGames: 'New Games',
    popularGames: 'Popular Games',
    followUs: 'Follow Us',
    disclaimer: 'All games belong to their original creators. We do not claim any rights to them.',
    introText: 'The best platform for free online games. No downloads, no registration, just fun!',
    quickLinks: 'Quick Links',
    popularCategories: 'Popular Categories',
    contactText: 'Have questions, suggestions, or feedback? We\'d love to hear from you!',
    aboutUs: 'About Us'
  },
  gameCard: {
    play: 'Play Now',
    new: 'New',
    popular: 'Popular'
  },
  shareButtons: {
    share: 'Share',
    copyLink: 'Copy Link',
    facebook: 'Share on Facebook',
    twitter: 'Share on Twitter',
    whatsapp: 'Share on WhatsApp',
    telegram: 'Share on Telegram',
    copied: 'Copied!'
  },
  searchBar: {
    search: 'Search',
    placeholder: 'Find your favorite games...'
  },
  share: {
    title: 'Share',
    copy: 'Copy Link',
    copied: 'Copied',
    instagramNotSupported: 'Instagram does not support direct link sharing'
  },
  defaultGameImage: {
    text: 'Game Image'
  }
}; 